import { useEffect, useRef } from "react";

const useDebounce = <T extends unknown[], U>(
  callback: (...arg: T) => PromiseLike<U> | U,
  delay: number | undefined
) => {
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  function clearTimer() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  }

  useEffect(() => {
    return clearTimer;
  }, []);

  const debounced = (...args: T): Promise<U> => {
    clearTimer();
    return new Promise((resolve) => {
      timeoutRef.current = setTimeout(() => resolve(callback(...args)), delay);
    });
  };

  debounced.cancel = clearTimer;

  return debounced;
};

export default useDebounce;
